<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="平台">
                    <a-select v-model="plat" :options="plats" style="width:250px"></a-select>
                </a-form-item>
                <a-form-item label="状态">
                    <a-select v-model="state" :options="states" style="width:250px"></a-select>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="query()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading"
                :pagination="pagination" :rowKey="(record, index) => { return index }" @change="change">
                <span slot="action" slot-scope="row">
                    <a-button @click="ban(row)" size="small" type="link" v-if="row.state == 'Normal'">
                        删除
                    </a-button>
                    <a-button @click="rest(row)" size="small" type="link" v-else>
                        恢复
                    </a-button>
                </span>
                <span slot="from_plat" slot-scope="row">
                    <span v-if="row.from_plat == 1">videoforce</span>
                    <span v-if="row.from_plat == 2">亿视推</span>
                    <span v-if="row.from_plat == 3">快车</span>
                    <span v-if="row.from_plat == 4">dev</span>
                </span>
                <!-- <span slot="detail" slot-scope="row">
                    <a-button @click="detail(row)" size="small" type="link">
                        查看
                    </a-button>
                    <a-modal v-model:visible="v_detail" title="详情" @ok="v_detail = false" :footer=null>
                        <a-form :form="form_detail" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                            <a-form-item label="公司">
                                <label>{{ form_detail.company_name }}</label>
                            </a-form-item>
                        </a-form>
                    </a-modal>
                </span> -->
            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            table: [],
            pagination: {
                current: 1,
                pageSize: 20,
                total: 0,
            },
            plat: '0',
            plats: [
                {
                    label: "全部",
                    value: "0"
                },
                {
                    label: "videoforce",
                    value: "1"
                },
                {
                    label: "亿视推",
                    value: "2"
                },
                {
                    label: "快车",
                    value: "3"
                },
                {
                    label: "dev",
                    value: "4"
                }
            ],
            state: '0',
            states: [{
                label: "全部",
                value: "0"
            },
            {
                label: "正常",
                value: "1"
            },
            {
                label: "关闭",
                value: "2"
            }],
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                }, {
                    title: "用户id",
                    dataIndex: "uid",
                },
                {
                    title: "用户名",
                    dataIndex: "username",
                },
                , {
                    title: "身份",
                    dataIndex: "type",
                }, {
                    title: "时间",
                    dataIndex: "create_time",
                }, {
                    title: "平台",
                    scopedSlots: { customRender: "from_plat" },
                },
                {
                    title: "状态",
                    dataIndex: "state",
                },
                {
                    title: "公司",
                    dataIndex: "company_name",
                },
                {
                    title: "网站",
                    dataIndex: "website",
                },
                // {
                //     title: "详情",
                //     scopedSlots: { customRender: "detail" },

                // },
                {
                    title: "操作",
                    scopedSlots: { customRender: "action" },

                },
            ],
            loading: false,
            v_detail: false,
            form_detail: {}
        };
    },
    created() {
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            this.$get("/user/list", {
                page: this.pagination.current,
                size: this.pagination.pageSize,
                from_plat: this.plat,
                state: this.state
            }).then((res) => {
                this.loading = false;
                this.table = res.data.data;
                this.pagination.total = res.data.total;
            });
        },
        change(pagination) {
            this.pagination = pagination;
            this.loadtable();
        },
        query() {
            this.pagination.current = 1;
            this.loadtable();
        },
        ban(row) {
            this.loading = true;
            post("/user/forbid", {
                uid: row.uid
            }).then(res => {
                this.loadtable();
                this.$message.success('删除完成');
            })
        },
        rest(row) {
            this.loading = true;
            post("/user/restore", {
                uid: row.uid
            }).then(res => {
                this.loadtable();
                this.$message.success('恢复完成');
            })
        },
        detail(row) {
            this.v_detail = true;
            this.form_detail = row;
        }
    },
};
</script>